/** HTML welcome email after successful membership registration (same content as legacy CheckoutStep). */
export function buildRegistrationWelcomeEmailHtml(
  firstName: string,
  selectedMembershipLower: string,
): { subject: string; fullHTML: string } {
  const subject = "Welcome to Connect by SMBF";
  const loginBtn = `
        <p style="text-align:center;">
          <a href="https://www.connect.smbf.global/login" target="_blank" style="background: linear-gradient(221deg, #2366CD 0%, #3A97A4 100%); color:#fff; padding:12px 28px; text-decoration:none; border-radius:6px; display:inline-block;">Login Now</a>
        </p>`;
  const onboardingMeetingLink = `
        <p>
          <a href="https://meetings-eu1.hubspot.com/waqas-mohammad/smbf-member-introductory-meeting" target="_blank" style="color:#2366CD; text-decoration:underline;">SMBF Member Introductory Meeting - Waqas Mohammad</a>
        </p>`;

  let body = "";

  if (
    selectedMembershipLower.includes("early stage") ||
    selectedMembershipLower.includes("youth")
  ) {
    const tierLabel = selectedMembershipLower.includes("early stage")
      ? "Early Stage Member"
      : "Youth Member";
    const tierArticle = tierLabel === "Youth Member" ? "a" : "an";
    body = `
        <p>Assalamu Alaikum ${firstName},</p>
        <p>You've successfully joined <b>Connect by SMBF</b> as ${tierArticle} <b>${tierLabel}</b>.</p>
        <p>Connect by SMBF was built to support early-stage Muslim entrepreneurs and business owners who are starting, building, or developing their business journey.</p>
        <p>To get started, please log in, complete your profile, and begin exploring the platform.</p>
        <p>As part of your membership, you now have access to:</p>
        <ul>
          <li>SMBF Member Onboarding &amp; Growth Call</li>
          <li>Early Stage Members Meet Up</li>
          <li>Early Stage Members Weekly Forum: every Sunday at 10:30am (UK time)</li>
          <li>Muslim Business Launchpad Course</li>
          <li>Unlimited connections and messaging with Early Stage Members on Connect</li>
          <li>Events, forums, and member networking opportunities</li>
        </ul>
        <p>Please book your Member Onboarding &amp; Growth call using the link below:</p>
        ${onboardingMeetingLink}
        <p>For the Early Stage Members Weekly Forum, you will receive the meeting link by email 48 hours before each session, as the link may change each week.</p>
        ${loginBtn}
        `;
  } else if (selectedMembershipLower.includes("business")) {
    body = `
        <p>Assalamu Alaikum ${firstName},</p>
        <p>You've successfully joined <b>Connect by SMBF</b> as a <b>Business Member</b>.</p>
        <p>Connect by SMBF has been built to help Muslim business owners grow their network, access opportunities, and build meaningful business relationships.</p>
        <p>To get started, please log in, complete your profile, and begin exploring the platform.</p>
        <p>As part of your membership, you now have access to:</p>
        <ul>
          <li>SMBF Member Onboarding &amp; Growth Call</li>
          <li>Weekly Business Members Forum: every Sunday at 11:30am (UK time)</li>
          <li>Requestable facilitated B2B matchmaking: eligible once per quarter</li>
          <li>50% discount on SMBF networking events globally</li>
          <li>Unlimited connections and messaging with Business and Early Stage Members on Connect</li>
        </ul>
        <p>You may also be eligible for additional paid services, including registering your company for Muslim Invest.</p>
        <p>Please book your Member Onboarding and Growth Call using the link below:</p>
        ${onboardingMeetingLink}
        <p>For the Weekly Business Members Forum, you will receive the meeting link by email 48 hours before each session, as the link may change each week.</p>
        ${loginBtn}
        `;
  } else if (selectedMembershipLower.includes("executive")) {
    body = `
        <p>Assalamu Alaikum ${firstName},</p>
        <p>You've successfully joined <b>Connect by SMBF</b> as an <b>Executive Member</b>.</p>
        <p>Connect by SMBF has been built to help Muslim business leaders access high-value connections, strategic introductions, and growth opportunities through the SMBF network.</p>
        <p>To get started, please log in, complete your profile, and begin exploring the platform.</p>
        <p>As part of your membership, you now have access to:</p>
        <ul>
          <li>SMBF Member Onboarding &amp; Growth Call</li>
          <li>1 x monthly B2B matchmaking introduction</li>
          <li>1 x free SMBF networking event per month globally</li>
          <li>Weekly Executive Members Forum: every Sunday at 9:30am (UK time)</li>
          <li>Unlimited connections and messaging with Executive, Business and Early Stage Members on Connect</li>
        </ul>
        <p>You may also be eligible for additional paid services, including Muslim Invest as an investor and SMBF International Trade Programmes.</p>
        <p>Please book your Member Onboarding and Growth Call using the link below:</p>
        ${onboardingMeetingLink}
        <p>For the Weekly Executive Members Forum, you will receive the meeting link by email 48 hours before each session, as the link may change each week.</p>
        ${loginBtn}
        `;
  } else {
    body = `
        <p>Assalamu Alaikum ${firstName},</p>
        <p>Welcome to <b>Connect by SMBF</b>. We're thrilled to have you on board!</p>
        ${loginBtn}
        `;
  }

  const fullHTML = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>${subject}</title>
      </head>
      <body style="margin:0; padding:0; font-family:Arial, Helvetica, sans-serif; background-color:#f4f6f8;">
        <table width="100%" cellspacing="0" cellpadding="0" bgcolor="#f4f6f8">
          <tr>
            <td align="center" style="padding:40px 20px;">
              <table width="600" cellspacing="0" cellpadding="0" bgcolor="#ffffff" style="border-radius:10px; border:1px solid #e0e0e0; overflow:hidden;">
                <tr>
                  <td align="center" style="background: linear-gradient(221deg, #2366CD 0%, #3A97A4 100%); padding:30px;">
                    <img src="https://drive.google.com/uc?export=view&id=17bPec3b1DFm41gg757oKNyTmP1942MOg" alt="Connect by SMBF" width="180" style="display:block; margin:0 auto;" />
                  </td>
                </tr>
                <tr>
                  <td style="padding:35px; font-size:15px; color:#333; line-height:1.6;">
                    ${body}
                    <p style="margin:30px 0 0; font-size:13px; color:#555;">Best regards,<br/>The SMBF Team</p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td align="center" style="padding:20px; font-size:11px; color:#888;">
              &copy; 2025 SMBF. All rights reserved.
            </td>
          </tr>
        </table>
      </body>
      </html>
      `;

  return { subject, fullHTML };
}
